var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-confirm-dia" },
    [
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.close },
          model: {
            value: _vm.showDia,
            callback: function ($$v) {
              _vm.showDia = $$v
            },
            expression: "showDia",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _vm.title
              ? _c("div", { staticClass: "tit" }, [_vm._v(_vm._s(_vm.title))])
              : _vm._e(),
            _vm.content
              ? _c("div", {
                  staticClass: "con",
                  domProps: { innerHTML: _vm._s(_vm.content) },
                })
              : _vm._e(),
            _c("div", { staticClass: "footer-btn" }, [
              _c(
                "div",
                {
                  staticClass: "btn btn-left",
                  on: { click: _vm.handleLeftBtn },
                },
                [_vm._v(_vm._s(_vm.leftBtnText))]
              ),
              _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleRightBtn } },
                [_vm._v(_vm._s(_vm.rightBtnText))]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }